module.exports = "<div class=\"app\">\n    <router-outlet></router-outlet>\n</div>\n<simple-notifications [options]=\"notificationOptions\"></simple-notifications>\n<loader></loader>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.html
// module id = 607
// module chunks = 0